import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EventServiceResponse, EventServiceRegistrationResponse} from '../../../../../../../../../../@shared/models/response.module';
import {formatDateDMYDots} from '../../../../../../../../../../@core/utils/utils.service';
import {DeleteModal} from '../../../../../../../../../../@shared/components/delete-modal/delete-modal';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {ToastService} from '../../../../../../../../../../@core/services/toast.service';
import {EditServiceRegistration} from './components/edit-service-registration/edit-service-registration';
import {AQH_EVE_11, AQH_EVE_33} from '../../../../../../../../../../@shared/models/input.module';
import {StorageService} from '../../../../../../../../../../@core/services/storage.service';

@Component({
  selector: 'app-view-service-registrations',
  standalone: false,
  templateUrl: './view-service-registrations.html',
  styleUrl: './view-service-registrations.css'
})
export class ViewServiceRegistrations implements OnInit {
  @Input() eventService!: EventServiceResponse;
  loading = false;
  hasUpdates = false;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private eventsService: EventsService,
    private toastService: ToastService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    console.log('Event Service with Registrations:', this.eventService);
  }

  reloadEventService() {
    if (!this.eventService) return;

    this.loading = true;
    const payload: AQH_EVE_11 = {
      event_id: this.eventService.event_id
    };

    this.eventsService.getEventServices(payload).subscribe({
      next: (services: EventServiceResponse[]) => {
        // Find and update the current event service
        const updatedService = services.find(s => s.event_service_id === this.eventService.event_service_id);
        if (updatedService) {
          this.eventService = updatedService;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toastService.error('Failed to reload registration data');
      }
    });
  }

  close() {
    this.activeModal.close(this.hasUpdates);
  }

  getRegistrationNumber(index: number): number {
    return index + 1;
  }

  getTotalRegistrations(): number {
    if (!this.eventService.event_service_registrations || this.eventService.event_service_registrations.length === 0) {
      return 0;
    }
    return this.eventService.event_service_registrations.reduce((total, registration) => {
      return total + (registration.num_registrations || 0);
    }, 0);
  }

  openEditRegistrationModal(registration: EventServiceRegistrationResponse) {
    const modalRef = this.modalService.open(EditServiceRegistration, { size: 'lg', centered: true });
    modalRef.componentInstance.registration = registration;

    modalRef.result.then((updated) => {
      if (updated) {
        // Mark that updates were made
        this.hasUpdates = true;
        // Reload the event service data to show updated registration
        this.reloadEventService();
      }
    }, () => {
      // Modal dismissed
    });
  }

  deleteRegistration(registration: EventServiceRegistrationResponse) {
    const modalRef = this.modalService.open(DeleteModal, { size: 'md', centered: true });
    modalRef.result.then((confirmed) => {
      if (confirmed) {
        const payload: AQH_EVE_33 = {
          event_service_registration_id: registration.event_service_registration_id,
          user_id: this.storageService.getUser().user_id
        };

        this.eventsService.cancelEventServiceRegistration(payload).subscribe({
          next: () => {
            this.toastService.success('Registration cancelled successfully');
            // Mark that updates were made
            this.hasUpdates = true;
            // Remove the registration from the list
            const index = this.eventService.event_service_registrations.findIndex(
              r => r.event_service_registration_id === registration.event_service_registration_id
            );
            if (index > -1) {
              this.eventService.event_service_registrations.splice(index, 1);
            }
          },
          error: () => {
            this.toastService.error('Failed to cancel registration');
          }
        });
      }
    }, () => {
      // Modal dismissed
    });
  }

  protected readonly formatDateDMYDots = formatDateDMYDots;
}
